var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-screen",attrs:{"id":"app"}},[_c('Calendar',{attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }